import { gql } from '@apollo/client'
import { MUTATION_STATE } from '../../fragments'

const PAYLOAD = 'DestroyVoohCampaignCreationPayload'

export const DELETE_VOOH_CREATION = gql`
  ${MUTATION_STATE(PAYLOAD)}
  mutation destroyVoohCampaignCreation($voohCreationId: ID!) {
    destroyVoohCampaignCreation(input: { voohCreationId: $voohCreationId }) {
      ...MutationState${PAYLOAD}Fields
    }
  }
`
